(() => {
  const TARGET = [245, 244, 239];
  const cache = new Map();
  const main = document.querySelector('main');
  if (!main) return;

  function isEligibleContext(img) {
    return Boolean(
      img.closest(
        'product-card, .product-card, [data-product-card], .product-grid__item, .product-media-container'
      )
    );
  }

  function sourceOf(img) {
    return img.currentSrc || img.src || '';
  }

  function isPrintifyMockup(img) {
    const src = sourceOf(img);
    return /cdn\.shopify\.com/i.test(src) && /_2048\.jpe?g(?:\?|$)/i.test(src);
  }

  function isEdgeWhite(data, i) {
    const r = data[i], g = data[i + 1], b = data[i + 2], a = data[i + 3];
    if (a < 240) return false;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    return r >= 248 && g >= 248 && b >= 248 && (max - min) <= 6;
  }

  async function clean(img) {
    if (!isEligibleContext(img) || !isPrintifyMockup(img)) return;
    img.classList.add('vibe-printify-mockup');
    img.closest('.product-media-container')?.classList.add('vibe-printify-mockup-container');
    const originalSrc = sourceOf(img);
    if (!originalSrc || img.dataset.vibeBgCleaning === originalSrc) return;

    const cached = cache.get(originalSrc);
    if (cached) {
      img.srcset = '';
      img.src = cached;
      img.dataset.vibeBgCleaning = originalSrc;
      return;
    }

    img.dataset.vibeBgCleaning = originalSrc;

    try {
      const source = new Image();
      source.crossOrigin = 'anonymous';
      source.decoding = 'async';
      source.src = originalSrc;
      if (source.decode) await source.decode();
      else await new Promise((resolve, reject) => {
        source.onload = resolve;
        source.onerror = reject;
      });

      const w = source.naturalWidth;
      const h = source.naturalHeight;
      if (!w || !h) return;

      const canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext('2d', { willReadFrequently: true });
      if (!ctx) return;

      ctx.drawImage(source, 0, 0);
      const image = ctx.getImageData(0, 0, w, h);
      const px = image.data;
      const total = w * h;
      const seen = new Uint8Array(total);
      const queue = new Int32Array(total);
      let head = 0;
      let tail = 0;

      const enqueue = (p) => {
        if (p < 0 || p >= total || seen[p]) return;
        const i = p * 4;
        if (!isEdgeWhite(px, i)) return;
        seen[p] = 1;
        queue[tail++] = p;
      };

      for (let x = 0; x < w; x++) {
        enqueue(x);
        enqueue((h - 1) * w + x);
      }
      for (let y = 0; y < h; y++) {
        enqueue(y * w);
        enqueue(y * w + (w - 1));
      }

      while (head < tail) {
        const p = queue[head++];
        const i = p * 4;
        px[i] = TARGET[0];
        px[i + 1] = TARGET[1];
        px[i + 2] = TARGET[2];

        const x = p % w;
        const y = (p / w) | 0;
        if (x > 0) enqueue(p - 1);
        if (x < w - 1) enqueue(p + 1);
        if (y > 0) enqueue(p - w);
        if (y < h - 1) enqueue(p + w);
      }

      ctx.putImageData(image, 0, 0);
      const cleaned = canvas.toDataURL('image/jpeg', 0.96);
      cache.set(originalSrc, cleaned);
      img.srcset = '';
      img.src = cleaned;
    } catch (err) {
      console.warn('Vibe mockup background cleanup skipped:', err);
    }
  }

  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting && entry.target instanceof HTMLImageElement) {
        clean(entry.target);
        observer.unobserve(entry.target);
      }
    }
  }, { rootMargin: '600px 0px' });

  function watch(root = main) {
    root.querySelectorAll?.('img').forEach((img) => {
      if (isEligibleContext(img) && isPrintifyMockup(img)) observer.observe(img);
    });
  }

  watch();

  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          if (node instanceof HTMLImageElement && isEligibleContext(node) && isPrintifyMockup(node)) observer.observe(node);
          watch(node);
        });
      } else if (
        mutation.type === 'attributes' &&
        mutation.target instanceof HTMLImageElement &&
        isEligibleContext(mutation.target) &&
        isPrintifyMockup(mutation.target)
      ) {
        observer.observe(mutation.target);
      }
    }
  }).observe(main, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset'] });
})();